module.exports = __webpack_public_path__ + "img/waiting-for-approval.8f5a99af.svg";